export default __webpack_public_path__ + "static/media/logo-footer.88a3b1ea.png";